import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
  showIcon?: boolean;
  variant?: 'primary' | 'secondary';
};
const variantClasses = {
  primary: 'border-gold bg-wine text-cream shadow-luxe hover:bg-burgundy focus-visible:ring-gold',
  secondary: 'border-gold bg-cream text-burgundy hover:bg-beige focus-visible:ring-burgundy'
};
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  onLinkClick,
  showIcon = true,
  variant = 'primary',
  ...props
}: ButtonProps) {
  const baseClasses = `inline-flex items-center justify-center gap-2.5 rounded-md border px-6 py-3.5 text-center text-sm font-bold tracking-[0.04em] transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-cream sm:px-8 sm:text-base ${variantClasses[variant]}`;
  const content = <>
      {showIcon && <ShoppingBagIcon size={18} strokeWidth={2} aria-hidden="true" className="shrink-0 text-champagne" data-id="element-45" data-mp="3bnkvenxuddw" />}
      {children}
    </>;
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      y: -2
    }} whileTap={{
      scale: 0.98
    }} data-id="element-46" data-mp="3qftu8hm28rl8">
        {content}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    y: -2
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-47" data-mp="1er2f4aorir5b">
      {content}
    </motion.button>;
}
export function CheckoutButton({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackCheckout} className={className} data-id="element-48" data-mp="1d8c3z1n1p3mo">
      {children}
    </Button>;
}